module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./angularApp/app/app.component.html
// module id = 1245
// module chunks = 7